(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

var holder = [];
var setTimeouts = [];
var slotNum = 3; //定義位數
var obj = {};

$(function () {
    genSlot();
});

// 開始跑桌機
$(document).on("click", '#slot-trigger', function () {
    setTimeout("$('.initpic').css('display', 'none')", 800);
    $('.pole').addClass('polemove');
    setTimeout(function () {
        getNumFromServer();
    }, 800);
    $('.btn-run').attr("disabled", "disabled");
    setTimeout("$('.hand').css('animation', 'none')", 800);
});

// 開始跑手機
$(document).on("click", '#gobtn-trigger', function () {
    $('.initpic').css('display', 'none');
    $('.pole').addClass('polemove');
    getNumFromServer();
    $('.btn-run').attr("disabled", "disabled");
    $('.gobtn:before').css('animation', 'none');
});

// 歸零
$(document).on("click", '.reset-btn', function () {
    $('.initpic').css('display', 'block');
    $("#winner").css('display', 'none');
    $("#slotpage").css('display', 'block');
    $('.btn-run').removeAttr("disabled");
    $('.pole').removeClass('polemove');
    $('.hand').css('animation', 'handmove 1.5s infinite');
    $('.gobtn:before').css('animation', 'light 2s ease infinite alternate;');
    $.each(setTimeouts, function (k, v) {
        clearTimeout(setTimeouts[k]);
    });
    setTimeouts.length = 0;

    var zero = '';
    for (var i = 0; i < slotNum; i++) {
        zero += "0";
    }
    goToNum(zero);
});

// 從server資料
function getNumFromServer() {
    var delay = 600; // 每組延遲幾秒
    var showItme = 6; //產生多少組效果才顯示答案

    var arr = [{
        prize_bg: "../../events/img/0522/bgagain.png",
        prize_pic: "",
        prize_no: "123",
        prize_name: "沒中獎",
        prize_coupon: ""
    }, {
        prize_bg: "../../events/img/0522/bgcongra.png",
        prize_pic: "../../events/img/0522/congra3.png",
        prize_no: "333",
        prize_name: "3D魔法面膜",
        prize_coupon: "3DMASK"
    }, {
        prize_bg: "../../events/img/0522/bgcongra.png",
        prize_pic: "../../events/img/0522/congra1.png",
        prize_no: "111",
        prize_name: "5V紅藜面膜",
        prize_coupon: "5VMASK"
    }, {
        prize_bg: "../../events/img/0522/bgcongra.png",
        prize_pic: "../../events/img/0522/congra2.png",
        prize_no: "222",
        prize_name: "杏仁酸面膜",
        prize_coupon: "POREMASK"
    }, {
        prize_bg: "../../events/img/0522/bgcongra.png",
        prize_pic: "../../events/img/0522/congra3.png",
        prize_no: "333",
        prize_name: "3D魔法面膜",
        prize_coupon: "3DMASK"
    },
    // {
    //     prize_bg: "../../events/img/0522/bgcongra.png",
    //     prize_pic: "../../events/img/0522/congra0.png",
    //     prize_no: "000",
    //     prize_name: "冰花面膜",
    //     prize_coupon: "ICEMASK",
    // },
    {
        prize_bg: "../../events/img/0522/bgcongra.png",
        prize_pic: "../../events/img/0522/congra1.png",
        prize_no: "111",
        prize_name: "5V紅藜面膜",
        prize_coupon: "5VMASK"
    }, {
        prize_bg: "../../events/img/0522/bgcongra.png",
        prize_pic: "../../events/img/0522/congra2.png",
        prize_no: "222",
        prize_name: "杏仁酸面膜",
        prize_coupon: "POREMASK"
    }, {
        prize_bg: "../../events/img/0522/bgcongra.png",
        prize_pic: "../../events/img/0522/congra3.png",
        prize_no: "333",
        prize_name: "3D魔法面膜",
        prize_coupon: "3DMASK"
    }, {
        prize_bg: "../../events/img/0522/bgcongra.png",
        prize_pic: "../../events/img/0522/congra1.png",
        prize_no: "111",
        prize_name: "5V紅藜面膜",
        prize_coupon: "5VMASK"
    }];

    function shuffle(arr) {
        for (var j, x, i = arr.length; i;) {
            j = Math.floor(Math.random() * i);
            x = arr[--i];
            arr[i] = arr[j];
            arr[j] = x;
        }
        return arr;
    };
    //打亂陣列重新排列
    shuffle(arr);

    // 得獎者前台顯示
    // console.log(arr[2]);

    $('#prize_pic').attr('src', arr[2].prize_pic);
    $('.bgresult').attr('src', arr[2].prize_bg);
    $('#prize_coupon').attr('value', arr[2].prize_coupon);

    if (arr[2].prize_name == '沒中獎') {
        $('.prize_coupon').css('display', 'none');
        $('.copy').css('display', 'none');
        $('.prize-reset').css('display', 'none');
        $('.noprize-reset').css('display', 'block');
    } else {
        $('.prize_coupon').css('display', 'block');
        $('.copy').css('display', 'block');
        $('.prize-reset').css('display', 'block');
        $('.noprize-reset').css('display', 'none');
    }

    var i = void 0;
    // 作效果
    for (i = 0; i < showItme; i++) {
        setTimeouts[i] = setTimeout(function () {
            goToNum(randomize());
        }, i * delay);
    }

    // 真正答案
    setTimeouts[i] = setTimeout(function () {
        goToNum(arr[2].prize_no);
    }, i * delay);

    // 真正答案
    setTimeouts[i + 1] = setTimeout(function () {
        $("#winner").show();
        $("#slotpage").css('display', 'none');
    }, i * delay + 2000);
}

// 初始化頁面
function genSlot() {
    for (var i = 0; i < slotNum; i++) {
        var htm = '<div class="holder">';
        htm += '<div class="digitHolder" id="slot_' + i + '">';
        htm += '<img src="../../events/img/0522/prize0.png"><br><img src="../../events/img/0522/prize1.png"><br><img src="../../events/img/0522/prize2.png"><br><img src="../../events/img/0522/prize3.png">';
        htm += '</div>';
        htm += '</div>';
        $('#bigholder').append(htm);
    }
}

// 轉到指定數字
function goToNum($str) {
    sliceNum($str);
    turnTheSlot();
}

// 切字串
function sliceNum(theNUM) {
    for (var i = 0; i < slotNum; i++) {
        var valu = theNUM.slice(i, i + 1);
        holder.push(valu);
    }
}

// 轉到指定數字
function turnTheSlot() {
    for (var i = 0; i < slotNum; i++) {
        var theValue = holder[i];
        var margin = parseInt($('.digitHolder').css('line-height')) * theValue;
        // console.log(theValue);
        $("#slot_" + i + "").css("margin-top", "-" + margin + "px");
    }

    // 清掉holder
    holder.length = 0;
}

// 產生隨機數
function randomize() {
    var num = '';

    for (var i = 0; i < slotNum; i++) {
        num += Math.floor(Math.random() * 4).toString();
    }

    return num;
}

},{}]},{},[1]);
